// API Response types
export interface ApiResponse<T = unknown> {
  code: number;
  message: string;
  data: T;
  status?: number;
  success?: boolean;
}

export interface ApiError {
  message: string;
  status: number;
  errors?: Record<string, string[]>;
}

// Pagination types
export interface PaginationParams {
  page?: number;
  limit?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
  data?: T[];
  limit?: number;
  totalPages?: number;
}

export interface Product {
  id: number;
  code: string;
  name: string;
  announced_name?: string;
  unit?: string;
  piece_unit?: string;
  packing_spec?: string;
  shelf_life_days?: number;
  storage_condition?: string;
  category_id?: number;
  technical_specs?: any;
  production_capacity_norm?: number;
  weight?: string;
  ingredients?: any;
  usage_instructions?: string;
  origin?: string;
  warnings?: any;
  note?: string;
  attributes?: Record<string, any>;
  status?: string;
  workshop_stock?: number;   // tồn "thành phẩm tự do" ở xưởng (đã SX, chưa đóng thùng)
}

export interface CreateProductRequest {
  code?: string;
  name: string;
  announced_name?: string;
  department_id?: number;
  category_id?: number;
  unit?: string;
  piece_unit?: string;
  packing_spec?: string;
  shelf_life_days?: number;
  storage_condition?: string;
  technical_specs?: any;
  production_capacity_norm?: number;
  weight?: string;
  ingredients?: any;
  usage_instructions?: string;
  origin?: string;
  warnings?: any;
  note?: string;
  attributes?: Record<string, any>;
}

export interface UpdateProductRequest {
  name?: string;
  announced_name?: string;
  category_id?: number;
  unit?: string;
  piece_unit?: string;
  packing_spec?: string;
  shelf_life_days?: number;
  storage_condition?: string;
  technical_specs?: any;
  production_capacity_norm?: number;
  weight?: string;
  ingredients?: any;
  usage_instructions?: string;
  origin?: string;
  warnings?: any;
  note?: string;
  attributes?: Record<string, any>;
}

export interface User {
  id: number;
  username: string;
  code?: string;
  email?: string;
  full_name?: string;
  department_id?: number;
  department_code?: string;
  department_name?: string;
  warehouse_id?: number;
  role?: string;
  role_code?: string;
  role_name?: string;
  status?: string;
  phone?: string;
  created_at?: string;
  is_active?: boolean;
  is_board?: boolean;
  job_title?: string;
  national_id?: string;
}
